import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Container, Typography, CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { TwilioVideoViewer } from '../components/twilio/TwilioVideoViewer';
import { VideoAPI } from '../api/VideoAPI';

const theme = createTheme({
    palette: {
        primary: { main: '#331966' }
    }
});

export const PublicServiceLive = () => {
    const { guid } = useParams();

    const getToken = useCallback(() => VideoAPI.getPublicToken(guid), [guid]);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5', py: 3 }}>
                <Container maxWidth="md">
                    <Typography variant="h5" component="h1" gutterBottom align="center" color="primary">
                        Acompanhamento ao vivo
                    </Typography>
                    <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
                        Transmissão do atendimento. Você entra apenas como espectador.
                    </Typography>
                    {guid ? (
                        <TwilioVideoViewer key={guid} getToken={getToken} />
                    ) : (
                        <Typography align="center">Link inválido.</Typography>
                    )}
                </Container>
            </Box>
        </ThemeProvider>
    );
};
